import localityState from './locality-state';
var LocalityCommonRegion = {
  CANBERRA: {
    id: 391,
    type: 'REGION',
    name: 'Canberra',
    slug: 'canberra-act',
    metaData: {
      state: 'ACT'
    },
    regionId: 391,
    state: localityState.ACT
  },
  QUEANBEYAN: {
    id: 557,
    type: 'REGION',
    name: 'Queanbeyan Region',
    slug: 'queanbeyan-region-nsw',
    metaData: {
      state: 'NSW'
    },
    regionId: 557,
    state: localityState.NSW
  },
  SOUTHERN_TABLELANDS: {
    id: 537,
    type: 'REGION',
    name: 'Southern Tablelands',
    slug: 'southern-tablelands-nsw',
    regionId: 537,
    metaData: {
      state: 'NSW'
    },
    state: localityState.NSW
  }
};
export default LocalityCommonRegion;